import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'

const MyLibraryEditRunningLessonConfirm = props => (
	<Confirm
		btOne='Cancel'
		btTwo='OK'
		alertTitle='Edit Lesson'
		alertMessage='This lesson has an active CODE. By editing, this CODE will be lost.'
		actionButtonType={0}
		actionOne={() => {
			props.actions.closeEditRunningLessonConfirm()
		}}
		actionTwo={() => {
			props.actions.editRunningLesson(props.lessonData)
		}}
		closeAction={() => {
			props.actions.closeEditRunningLessonConfirm()
		}}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeEditRunningLessonConfirm: myLibraryActions.closeEditRunningLessonConfirm,
		editRunningLesson: myLibraryActions.editRunningLesson,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryEditRunningLessonConfirm)
